import { createSlice } from "@reduxjs/toolkit";

const PageIDSession = createSlice({
  name: "PageIDSession",
  initialState: "",
  reducers: {
    savePageIDSession: (state, action) => action.payload,
  },
});

export default PageIDSession;
